<template>
   <div id="content">
      <div class="content-wrap py-0">
         <div class="section my-0 text-pop-image"
            style="background-image: url('https://assets.blog.theoutbackbowl.com/Outback_Bowl_V1_217f8f3517.jpg');"
         >
            <div class="container">
               <div class="row justify-content-between align-items-center align-items-xl-end">
                  <div class="col-lg-6 col-xxl-5 text-center text-lg-start">
                     <h1 class="display-4 fw-bolder ls-n-1 text-pop-image-text">The Outback Bowl</h1>
                     <p class="lead fw-normal mb-5 text-pop-image-text"> 
                        August. It is at this time of each year where we, the Four Gentlemen of the Bloomin' Onion™, 
                        embark upon our 18-week journey to a destiny which only the Football Gods are privy. 
                        Heartbreak, humiliation, and several hundred dollars of financial loss will be the fate of one. 
                        But in front of which seat the waiter will drop the check - that is far from certain.
                     </p>
                  </div>
                  <div class="col-lg-6 col-xxl-5 text-center text-lg-start">
                     <div style="text-align: center;">
                        <video style="width: 100%; height: auto;" controls poster="https://assets.blog.theoutbackbowl.com/OBB_Full_picture_36d945d5f1.png">
                           <source src="https://assets.blog.theoutbackbowl.com/OBB_2024_4_1_ab213d4817.mp4" type="video/mp4">
                           Your browser does not support the video tag.
                        </video>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="section my-0">
            <div class="container">
               <div class="row g-0 align-items-md-stretch align-items-lg-center">
                  <div class="col-xl-7 col-md-6 img-overlap">
                     <img src="https://assets.blog.theoutbackbowl.com/maxresdefault_bdeba42163.jpg" alt="..." class="h-100" style="object-fit: cover;">
                  </div>
                  <div class="col-xl-5 col-md-6 bg-white">
                     <div class="position-absolute start-0 top-0 w-100 h-100 bg-color bg-opacity-10"></div>
                     <p class="color op-06 text-uppercase ls-4 small mb-3">Know More About Us</p>
                     <h1 class="display-4 mb-4">{{ appConfigs.general.metadata.home }}</h1>
                     <p class="color">
                        Whose strategy will succeed? Whose will fail? Will the islands be fare or their seas be treacherous? 
                        Is there safety in numbers, or will the road less traveled make all the difference? 
                        Will lightning strike twice, or on virgin wallets? What is The Outback Bowl? 
                        What the hell are you guys even talking about? Who made this website?
                     </p>
                     <a href="/about" class="button button-small border-color button-border  m-0 color h-bg-color h-text-light">About Us</a>
                  </div>
               </div>
            </div>
         </div>
         <div class="section my-0">
            <div class="d-flex align-items-center">
               <div class="container">
                  <div class="row justify-content-center mb-5">
                     <div class="col-xl-6 col-lg-8 text-center">
                        <h3 class="h1 fw-bold mb-3">Meet the Outbackers</h3>
                     </div>
                  </div>
                  <div class="row justify-content-center">
                     <div class="col-lg-6 mb-5">
                        <div class="row team team-list rounded-5 g-0 align-items-center rounded-4 overflow-hidden">
                           <div class="col-md-4 team-image col-sm-5 d-flex align-self-stretch">
                              <img src="https://assets.blog.theoutbackbowl.com/bryant_79a88bf4bc.jpg" alt="Bryant Bost" style="object-fit: contain" loading="lazy" decoding="async">
                           </div>
                           <div class="col-md-8 col-sm-7 p-4">
                              <div class="team-desc text-start">
                                 <div class="team-title pt-0 mb-3">
                                    <h4>Bryant Bost</h4>
                                 </div>
                                 <p class="mb-3">
                                    The most handsome of the Outbackers, Bryant largely employs a strategy of favoring the home team. Bryant's
                                    seasons are historically "feast or famine," as he is the only player with multiple first place and multiple last 
                                    place finishes. 
                                 </p>
                                 <p>
                                    <b>Outback Bowl Losses:</b> 2021, 2023, 2024
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="col-lg-6 mb-5">
                        <div class="row team team-list rounded-5 g-0 align-items-center rounded-4 overflow-hidden">
							<div class="col-md-4 team-image col-sm-5 d-flex align-self-stretch">
                              <img src="https://assets.blog.theoutbackbowl.com/tom_11e4339984.png" alt="Tom Priester" style="object-fit: contain" loading="lazy" decoding="async">
                           </div>
                           <div class="col-md-8 col-sm-7 p-4">
                              <div class="team-desc text-start">
                                 <div class="team-title pt-0 mb-3">
                                    <h4>Tom Priester</h4>
                                 </div>
                                 <p class="mb-3">
                                    Tom is the only Outbacker to have never been presented the check, yet Tom is routinely responsible 
                                    for the lion's share of the bill at each Loser's Dinner. Tom's strategy is simple: pick on pure instinct. 
                                    He refers to this as the Pick the Winners strategy.
                                 </p>
                                 <p>
                                    <b>Outback Bowl Losses:</b> None
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="col-lg-6 mb-5">
                        <div class="row team team-list rounded-5 g-0 align-items-center rounded-4 overflow-hidden">
							<div class="col-md-4 team-image col-sm-5 d-flex align-self-stretch">
                              <img src="https://assets.blog.theoutbackbowl.com/grey_01ee95841c.jpg" alt="Grey Gordon" style="object-fit: contain" loading="lazy" decoding="async">
                           </div>
                           <div class="col-md-8 col-sm-7 p-4">
                              <div class="team-desc text-start">
                                 <div class="team-title pt-0 mb-3">
                                    <h4>Grey Gordon</h4>
                                 </div>
                                 <p class="mb-3">
                                    There's one thing that you can count on in The Outback Bowl, and that is Grey living and 
                                    dying over the outcome of each game.  Grey has sweated out (heavily) every Sunday since 2018. 
                                    Grey employes a varied strategy to make his picks.
                                 </p>
                                 <p>
                                    <b>Outback Bowl Losses:</b> 2018
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="col-lg-6 mb-5">
                        <div class="row team team-list rounded-5 g-0 align-items-center rounded-4 overflow-hidden">
							<div class="col-md-4 team-image col-sm-5 d-flex align-self-stretch">
                              <img src="https://assets.blog.theoutbackbowl.com/randy_4387f20133.jpg" alt="Randy Short" style="object-fit: contain" loading="lazy" decoding="async">
                           </div>
                           <div class="col-md-8 col-sm-7 p-4">
                              <div class="team-desc text-start">
                                 <div class="team-title pt-0 mb-3">
                                    <h4>Randy Short</h4>
                                 </div>
                                 <p class="mb-3">
                                    In his day job, Randy is a professional data scientist. This makes it all the more puzzling that 
                                    Randy's proprietary "model" to predict the outcome of each game has made him a 4-time loser. Known 
                                    for his contrarian picks, he is nicknamed the "Island Boi."
                                 </p>
                                 <p>
                                    <b>Outback Bowl Losses:</b> 2019, 2020, 2022, 2025
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="section bg-color bg-opacity-10 my-0">
            <div class="container py-5">
               <div class="row justify-content-center mb-4">
                  <div class="col-md-6 text-center">
                     <p class="color text-uppercase ls-3 small mb-3">Blog</p>
                     <h3 class="display-5 mb-5">Our Latest Posts</h3>
                  </div>
               </div>
               <div class="row col-mb-50 posts-md">
                  <div class="col-lg-4 entry mb-0" v-for="post in posts.slice(0, 3)" :key=post.id>
                     <ArticlePreview :post="post" />
                  </div>
               </div>
            </div>
         </div>
         <div class="section bg-transparent my-0 py-0">
            <div class="container-fluid">
               <div class="clear"></div>
               <div class="row flex-md-row-reverse align-items-md-center">
                  <div data-v-4f98d3ad="" class="col-md-6 px-lg-0 min-vh-50 min-vh-lg-75 d-flex align-self-stretch" style="background: url(&quot;https://assets.blog.theoutbackbowl.com/Outback_Steakhouse_Bloomin_Onion_062123_Tout_2b5b66adcab742eeb20ccac214709b57_d626478661.jpg&quot;) center center / cover no-repeat;"></div>
                  <div class="col-md-6 p-5 p-lg-6">
                     <h3 class="fs-2 fw-medium mb-4 px-lg-5">Explore Our Community Forum</h3>
                     <p class="px-lg-5 mb-5">
                        Looking for more Outback content? Dive into our community forum, where experienced 
                        Outbackers and experts share insights, tips, and stories to help you ensure can accurately pick the winners. 
                        Join the conversation, ask questions, and connect with fellow Outbackers enthusiasts today.
                        <br>
                        <br>
                        <a href="/community" class="read-more ls-1 text-uppercase border-bottom border-color small h-color h-op-08 ">Read More</a>
                     </p>
                  </div>
               </div>
            </div>
         </div>
         <div class="section bg-transparent my-0 py-0">
            <div class="container-fluid py-6">
               <div class="row justify-content-center mx-auto mw-md gx-5">
                  <div class="col">
                     <p class="h6 mb-0">
                        Content and advice shared on this platform regarding represent the opinions of our community members 
                        and should not be considered betting advice.  We are morons.  If you have inquiries, wish to rectify misinformation, or 
                        seek clarification about our community, feel free to <a href="/about#contact">Contact Us</a>.
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script lang="ts">
import { Post } from '@/models/Cms';
import { loadNewContent } from '@/utils/cms';
import { convertTimeToDate } from '@/utils/time';
import { Vue, Options } from 'vue-class-component';
import { APP_CONFIGS } from '@/main';
import { setPageMetaTags } from '@/utils/seo';
import { emitPrerenderEvent, detectPrerenderedPage } from '@/utils/seo';
import ArticlePreview from "@/components/post/ArticlePreview.vue";

@Options({
    methods: {
        convertTimeToDate
    },
    components: {
        ArticlePreview,
    }
})
export default class ObbHome extends Vue {

    isApiCallInProgress = false;
    posts: Post[] = [];

    public async mounted(): Promise<void> {
      this.isApiCallInProgress = true;

      // Set SEO meta tags
      setPageMetaTags(
         this.appConfigs.general.metadata.home,
         this.appConfigs.general.metadata.homeDescription || this.appConfigs.general.metadata.about,
         this.appConfigs.assets.logoImage,
         window.location.href,
         {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": this.appConfigs.general.metadata.home,
            "description": this.appConfigs.general.metadata.homeDescription || this.appConfigs.general.metadata.about
         },
         {
            siteName: this.appConfigs.general.name,
            themeColor: this.appConfigs.general.display?.themeColor,
         }
      );

      // Fetch data
      try {
         this.posts = await loadNewContent();
      } catch (err) {
         console.error(err);
      } finally {
         this.isApiCallInProgress = false;
      }

      // Emit prerender event
      emitPrerenderEvent();
   }

    public convertTimeToDate(dateString: string): string {
		return convertTimeToDate(dateString);
    }

    get appConfigs() {
      return APP_CONFIGS;
    }

    get isPrerendered(): boolean {
      return detectPrerenderedPage();
   }

}
</script>

<style scoped>
.block-ellipsis {
    display: -webkit-box;
    max-width: 100%;
    margin: 0 auto;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 75px;
}
</style>